import React, { useEffect } from "react";
import axios from "axios";
import { useState } from "react";

import { Link, useNavigate, useParams } from "react-router-dom";

function ViewApproval() {
  const [view, setView] = useState();
  const [formValues, setFormValues] = useState({});
  const { mpi_id } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    getDataView();
  }, []);

  const getDataView = async () => {
    try {
      const data = await axios.get(
        `${process.env.REACT_APP_NODE_URL}/admin/publisher/unapproved/view/` +
          mpi_id
      );
      if (data.data.data[0] !== undefined) setView(data.data.data[0]);
      console.log(data.data.data[0]);
    } catch (e) {
      console.log(e);
    }
  };

  const ValidateFormData = (e) => {
    e.preventDefault();
    axios
      .put(
        `${process.env.REACT_APP_NODE_URL}/admin/publisher/unapproved/edit/` +
          mpi_id,
        view
      )
      .then(function (response) {
        if (response.status === 200) {
          navigate("/admin/new-reg/approve");
        }
        console.log(response.data, "responses");
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const getDownload = (filename) => {
    console.log(filename, "filename");
    axios
      .post("https://s3bucket-node.next99.com/preSignedURL", {
        key: filename,
      })
      .then((res) => {
        document.getElementById("download").setAttribute("href", res.data);
        document.getElementById("download").click();
      })
      .catch((err) => console.log(err.response.data));
  };
  const HandleFormData = (name, value) => {
    console.log("====================================");
    console.log(name, value);
    console.log("====================================");
    // setFormValues({ ...formValues, [event.target.name]: event.target.value });
    const fieldvalue = { ...view };
    fieldvalue[name] = value;
    setView(fieldvalue);
  };
  return (
    <>
      <div>
        <h1>ViewApproval</h1>
      </div>
      {view !== undefined ? (
        <form onSubmit={ValidateFormData}>
          <div className="container-fluid-bg">
            <div className="row mt-3 mb-4">
              <div className="col-4">
                <label className="form-label float-start mb-2">Name:</label>
                <input
                  className="form-control mb-3"
                  type="text"
                  name="name"
                  id="name"
                  onChange={(event) =>
                    HandleFormData(event.target.name, event.target.value)
                  }
                  defaultValue={view.firstname + " " + view.lastname}
                />
                <label className="form-label float-start mb-2">Category:</label>
                <input
                  className="form-control mb-3"
                  type="text"
                  name="category"
                  id="category"
                  defaultValue={view.category}
                  onChange={(event) =>
                    HandleFormData(event.target.name, event.target.value)
                  }
                />
                <label className="form-label float-start mb-2">
                  Description:
                </label>
                <input
                  className="form-control mb-3"
                  type="text"
                  name="description"
                  id="description"
                  onInput={(event) =>
                    HandleFormData(event.target.name, event.target.value)
                  }
                  defaultValue={view.description}
                />
                <label className="form-label float-start mb-2">
                  Domain Authority:
                </label>
                <input
                  className="form-control mb-3"
                  type="text"
                  name="domain_authority"
                  onInput={(event) =>
                    HandleFormData(event.target.name, event.target.value)
                  }
                  id="domainauthority"
                  defaultValue={view.domain_authority}
                />
                <div className="float-start mt-4 mb-3">
                  <input
                    type="checkbox"
                    className="me-3"
                    id="feature_site"
                    name="is_featured"
                    defaultChecked={view.is_featured === 1 ? true : false}
                    onClick={(event) =>
                      event.target.checked
                        ? HandleFormData(event.target.name, 1)
                        : HandleFormData(event.target.name, 0)
                    }
                  />
                  <span>Featured sites</span>
                </div>
              </div>
              <div className="col-4">
                <label className="form-label float-start mb-2">Email:</label>
                <input
                  className="form-control mb-3"
                  type="email"
                  name="email"
                  id="email"
                  onChange={(event) =>
                    HandleFormData(event.target.name, event.target.value)
                  }
                  defaultValue={view.email}
                />
                <label className="form-label float-start mb-2">
                  Email Verified:
                </label>
                <input
                  className="form-control mb-3"
                  type="text"
                  name="emailverified"
                  id="emailverified"
                  onChange={(event) =>
                    HandleFormData(event.target.name, event.target.value)
                  }
                  defaultValue={view.email_verified}
                />
                <label className="form-label float-start mb-2">
                  Article Length:
                </label>
                <input
                  className="form-control mb-3"
                  type="text"
                  name="articlelength"
                  id="articlelength"
                  defaultValue={view.article_length}
                  onChange={(event) =>
                    HandleFormData(event.target.name, event.target.value)
                  }
                />
                <label className="form-label float-start mb-2">
                  Languages:
                </label>
                <input
                  className="form-control mb-3"
                  type="text"
                  name="languages"
                  id="languages"
                  onChange={(event) =>
                    HandleFormData(event.target.name, event.target.value)
                  }
                  defaultValue={view.languages}
                />
                <label className="form-label float-start mb-2">
                  Trust Flow:
                </label>
                <input
                  className="form-control mb-3"
                  type="text"
                  name="trust_flow"
                  id="trustflow"
                  defaultValue={view.trust_flow}
                  onChange={(event) =>
                    HandleFormData(event.target.name, event.target.value)
                  }
                />
                {/* <label className="form-label float-start">Ahref:</label>
                <input
                  className="form-control"
                  type="text"
                  name="ahref"
                  id="ahref"
                  onChange={(event) => HandleFormData(event)}
                  defaultValue={view.ahref}
                  required
                /> */}
                {/* <label className="form-label float-start">
                  Minimum Unique User:
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="minimum_unique_user"
                  id="minuniuser"
                  onInput={(event) => HandleFormData(event)}
                  defaultValue={view.minimum_unique_user}
                  required
                /> */}
              </div>
              <div className="col-4">
                <label className="form-label float-start mb-2">
                  Parent Topic:
                </label>
                <input
                  className="form-control mb-3"
                  type="text"
                  name="parent_topic"
                  id="parenttopic"
                  onInput={(event) =>
                    HandleFormData(event.target.name, event.target.value)
                  }
                  defaultValue={view.parent_topic}
                />
                <label className="form-label float-start mb-2">
                  Portal Name:
                </label>
                <input
                  className="form-control mb-3"
                  type="text"
                  name="portal_name"
                  id="portalname"
                  onInput={(event) =>
                    HandleFormData(event.target.name, event.target.value)
                  }
                  defaultValue={view.portal_name}
                />
                <label className="form-label float-start mb-2">
                  Publishing Cost
                </label>
                <input
                  className="form-control mb-3"
                  type="text"
                  name="pubcost"
                  id="pubcost"
                  onChange={(event) =>
                    HandleFormData(event.target.name, event.target.value)
                  }
                  defaultValue={view.publishing_cost}
                />
                <label className="form-label float-start mb-2">
                  Target Country:
                </label>
                <input
                  className="form-control mb-3"
                  type="text"
                  name="tarcoun"
                  id="tarcoun"
                  defaultValue={view.target_country}
                  onChange={(event) =>
                    HandleFormData(event.target.name, event.target.value)
                  }
                />
                <div className="float-start mt-4">
                  <label className="form-label">GA Analytics:</label>
                  {/* <input
                  className="form-control"
                  type="text"
                  name="ga"
                  id="ga"
                  onChange={(event) => HandleFormData(event)}
                  defaultValue={view.ga_analytics}
                  required
                /> */}
                  {/* <a href="https://next99.nyc3.digitaloceanspaces.com/Marketplace-development/1190117156-test_marketplace.pdf">
                    GA Analytics Download
                  </a> */}

                  <button
                    type="button"
                    className="btn btn-success ms-2"
                    onClick={() => getDownload(view.ga_analytics)}
                  >
                    Download
                  </button>
                  <a download="download" id="download" hidden>Download</a>
                </div>
              </div>
            </div>
            <button type="button" className="btn btn-md btn-danger mt-4 me-3">
              <Link
                to="/admin/new-reg/approve"
                className="text-white text-decoration-none"
              >
                Back
              </Link>
            </button>
            <button type="submit" className="btn btn-md btn-primary mt-4">
              Update
            </button>
          </div>
        </form>
      ) : (
        <p className="my-5">No Record Found</p>
      )}
    </>
  );
}

export default ViewApproval;
